module.exports = __webpack_public_path__ + "img/transfer_within_a_station.de2211fe.svg";